<template>
<div >
    <div class="form-group">
        <label for="anno"><strong>{{label.toUpperCase()}}</strong></label>
        <select :id="season_year" :required="props.required" :disabled="!props.isActive" @change="$emit('update',year,$event)" class="form-control" v-model="year" >
          <option v-if="props.optionBase" value="0"> -- TUTTI GLI ANNI -- </option>  
          <option v-for="(item,index) in items" :value="item.seasonYear" :key="index">{{item.seasonYear}}</option>        
        </select>  
      </div>  
</div>



</template>
<script>

import api from '@/api';
export default {
  //props : ['isActive','required','optionBase','_year','_label','_id'] , 
  props : ['props'] , 
  components: {},
  data() {
    return {

      year                   : 0,
      items                  : [],
      spinner                : false,
      label                  : this.props.label ? this.props.label + ' Anno' : 'Anno',
      season_year            : 'season_year'

     
     
    };
  },
  mounted: function() {
  
  },
  created: function() {
      this.getData()
      

      //this.label = this._label ? this._label : 'Anno'
  },
  methods: 
  {
    async getData()
    {
            
      var json   = {'sp'  : 'spYearSelect'} 
      await api.post(json).then(res => {
          
         
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]      
              this.year = this.props.year           
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

      
    },
      
  
}

}
</script>
<style scoped>

</style>